<template>
  <div class="index__conteiner text-center">
    <!-- <tipping/> -->
    <h1>自分botを作ってみよう！</h1>
    <h3 v-if="!isLogin" class="index__description">
      Aitter -ついじぇね- は、「あなたっぽい」ツイートを自動生成するサービスです。<br>ツイートすればするほど学習データが増えてあなたらしくなります
      </h3>
      <p class="index__attention">
        <br>鍵アカウントの場合、
        <br>初回ツイート生成時のみ鍵を外して頂けたら、それ以降は鍵アカウントでも使用可能です。
      </p>
      <div class="account__tweetgenerate">
        <select-getenrate-user
          @generateScreenName="generateAccountName"
        ></select-getenrate-user>
      </div>
      <generate-tweet-button
      :screen_name="generateScreenName"
      >
      </generate-tweet-button>
      <h2 v-if="!isLogin" class="login__attention">
        ログインするとアカウント名入力省略・過去のついじぇね生成結果が見られます<br>
        <login />
      </h2>
      <div class="error__attention">
        *スマホでログイン時にうまくログインされないことがあるようです。<br>
        その際はお手数ですがテキストボックスにアカウント名を入力してください。
      </div>
      <!-- <play-ranking/>
      <register-ranking/> -->
      <div>
        <tipping />
        <twitter-time-line></twitter-time-line>
      </div>
        <!-- <index-explain></index-explain> -->
  </div>
</template>

<script>
import Login from '../common/Login'
import GenerateTweetButton from '../GenerateTweetButton'
import SelectGenerateUser from '../SelectGenerateUser'
import TwitterTimeLine from '../common/TwitterTimeLine'
// import IndexExplain from '../IndexExplain'
// import PlayRanking from '../common/PlayRanking'
// import RegisterRanking from '../common/RegisterRanking'
import Tipping from '../common/Tipping'
export default {
  name: 'Index',
  data() {
    return {
      selectOtherUserName: '',
      selectOwnUserCheck: true,
      generateScreenName: '',
      generateAccount: ''
    }
  },
  components: {
    'login': Login,
    'generate-tweet-button': GenerateTweetButton,
    'twitter-time-line': TwitterTimeLine,
    'select-getenrate-user': SelectGenerateUser,
    // 'index-explain': IndexExplain,
    // 'play-ranking': PlayRanking,
    // 'register-ranking':RegisterRanking
    'tipping': Tipping
  },
  methods: {
    generateAccountName (generateAccount) {
      this.generateScreenName = generateAccount
    }
  },
  computed: {
    isLogin () {
      return this.$store.getters['auth/check']
    },
    userinfo () {
      return this.$store.getters['auth/user']
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1 {
  font-weight: bold;
  font-size: 24px;
}
h2 {
  font-weight: bold;
  font-size: 20px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.index__description {
  font-size: small;
  padding: 10px;
}
.index__conteiner {
  margin: auto;
}
.index__attention {
  color:red;
  font-weight: bold;
}

.error__attention {
  color:red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Index.vue